import React from "react";
import { Typography, Avatar, IconButton } from "@mui/material";
import {
  Close as CloseIcon,
  MoreVert as MoreVertIcon,
} from "@mui/icons-material";

const COLORS = [
  "#6366F1",
  "#22C55E",
  "#F59E0B",
  "#EF4444",
  "#06B6D4",
  "#A855F7",
];

const getColorFromString = (str = "") => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % COLORS.length;
  return COLORS[index];
};

const getInitials = (name = "") => {
  const parts = name.trim().split(" ");
  if (parts.length === 0 || !parts[0]) return "";
  const first = parts[0]?.[0] || "";
  const second = parts[1]?.[0] || "";
  return `${first}${second}`.toUpperCase();
};

const ChatHeader = ({
  title,
  subtitle,
  avatarId,
  onClose,
  onMouseDown, // Para habilitar el arrastre de la ventana si es flotante
  showCloseButton = true,
  extraActions,
  isWhats,
}) => {
  const avatarColor = isWhats ? "#22C55E" : "#036CF5";

  const initials = title ? getInitials(title) : "";
  console.log("initials: ", title, subtitle);
  return (
    <div style={styles.header} onMouseDown={onMouseDown}>
      <div style={styles.leftSection}>
        <Avatar
          style={{
            ...styles.avatar,
            backgroundColor: avatarColor,
          }}
        >
          {initials}
        </Avatar>
        <div style={styles.textContainer}>
          <Typography style={styles.title}>{title}</Typography>
          {subtitle && (
            <Typography style={styles.subtitle}>{subtitle}</Typography>
          )}
        </div>
      </div>

      <div style={styles.rightSection} onMouseDown={(e) => e.stopPropagation()}>
        {extraActions}
        <IconButton size="small" style={styles.iconBtn}>
          <MoreVertIcon style={styles.icon} />
        </IconButton>
        {showCloseButton && onClose && (
          <IconButton size="small" onClick={onClose} style={styles.iconBtn}>
            <CloseIcon style={styles.iconClose} />
          </IconButton>
        )}
      </div>
    </div>
  );
};

const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 16px",
    backgroundColor: "var(--chat-bg-header, #f0f2f5)",
    borderBottom: "1px solid var(--chat-border, #e9edef)",
    userSelect: "none",
    cursor: "grab",
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  avatar: {
    width: "40px",
    height: "40px",
    fontSize: "14px",
    fontWeight: "600",
    fontFamily: "Raleway, sans-serif",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontSize: "15px",
    fontWeight: "600",
    color: "var(--chat-text-primary, #111b21)",
    fontFamily: "Raleway, sans-serif",
    lineHeight: "1.2",
  },
  subtitle: {
    fontSize: "12px",
    color: "var(--chat-text-secondary, #667781)",
    fontFamily: "Raleway, sans-serif",
    marginTop: "2px",
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  iconBtn: {
    padding: "6px",
  },
  icon: {
    color: "var(--chat-icon, #54656f)",
    fontSize: "22px",
  },
  iconClose: {
    color: "var(--chat-icon, #54656f)",
    fontSize: "20px",
  },
};

export default ChatHeader;
